import React, {ReactNode} from 'react';
import {t} from '@lingui/core/macro';

import {IMessengerChatAdd} from 'entities/notification';
import MainModal from 'shared/ui/Modal/MainModal';
import Button from 'shared/ui/Button/Button/Button';

import NotifyChannelIntro from '../NotifyChannelIntro';

import BotChatForm from './BotChatForm';

import styles from '../NotifyChannels.module.scss';

type AddMutation = readonly [
    (_data: IMessengerChatAdd) => Promise<{data?: unknown, error?: unknown}>,
    {isLoading: boolean},
];

interface IBotChatModalProps {
    open: boolean,
    handleClose: () => void,
    header: string,
    intro: ReactNode,
    botUrl: string,
    buttonIcon: ReactNode,
    useAddMutation: () => AddMutation,
}

const BotChatModal: React.FC<IBotChatModalProps> = ({
    open,
    handleClose,
    header,
    intro,
    botUrl,
    buttonIcon,
    useAddMutation,
}) => {
    const [add, {isLoading}] = useAddMutation();

    const handleBotClick = () => {
        window.open(botUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <MainModal
            header={header}
            open={open}
            handleClose={handleClose}
            size="md"
        >
            <NotifyChannelIntro text={intro}>
                <Button
                    className={styles.link}
                    onClick={handleBotClick}
                >
                    <span>{buttonIcon}</span>
                    {t`Получить токен`}
                </Button>
            </NotifyChannelIntro>
            <BotChatForm add={add} isLoading={isLoading} onSuccess={handleClose} onClose={handleClose}/>
        </MainModal>
    );
};

export default BotChatModal;
